import React, { useEffect, useState } from 'react';
import UserDetailsForm from '../../components/UserDetailsForm';
import { ReactComponent as DeleteIcon } from '../../assets/delete.svg';
import { ReactComponent as EditIcon } from '../../assets/edit.svg';
import { useDispatch, useSelector } from 'react-redux';
import './choose-menu.css';
import { pageAction } from '../../redux_files/actions/page_actions';
import FOOD_ITEMS from './data/food-items';
import SelectItems from './components/select-items';
import { calculateDistance as calculateDistanceUtil, handleUseCurrentLocation as handleUseCurrentLocationUtil } from '../../utils/deliveryUtils';
import { FREE_DELIVERY_RADIUS_KM, DELIVERY_CENTER } from '../../utils/locationConstants';
import {CHOOSE_MENU_CONTEXT} from '../../utils/constants.js';
import { round2Decimal } from '../../utils/common.js';
import { submitOrderRequest, initiatePaymentRequest } from './choose-menu-actions';

// Order summary component
function OrderSummary({ selectedItems, orderTotal, setEditItemName, setSelectedItems, showEditRemove, deliveryInfo, customerDetails, stepName }) {
  // once we have deliveryInfo from location component, we can show delivery charge and message here
  // Inline error/info message state
  const [deliveryMsg, setDeliveryMsg] = useState('');
  useEffect(() => {
    if (deliveryInfo && deliveryInfo.deliveryDistance > 0) {
      if (deliveryInfo.deliveryCharge > 0) {
        setDeliveryMsg(`${deliveryInfo.message}`);
      } else if (deliveryInfo.deliveryCharge === 0) {
        setDeliveryMsg(deliveryInfo.message);
      } else if (deliveryInfo.deliveryCharge === undefined && deliveryInfo.message) {
        setDeliveryMsg(deliveryInfo.message);
      } else {
        setDeliveryMsg('');
      }
    } else {
      setDeliveryMsg('');
    }
  }, [deliveryInfo]);

  if (!selectedItems || selectedItems.length === 0) return null;
  return (
    <div className={`order-summary-bar${stepName === 'orderSummary' ? 'choose-menu-order-summary-special' : ' choose-menu-order-summary'}`}>
     
      {selectedItems.length > 0 && (
        <div className="order-summary-bar">
          {stepName !== "orderSummary" && (
            <div style={{fontWeight: 600, marginBottom: 6}}>Order Summary</div>
          )}
          {stepName === "orderSummary" && customerDetails && (
            <div className="customer-details-summary">
              <div className="customer-details-title">Customer Details</div>
              <div className="customer-details-row">
                <span className="customer-details-label">Name</span>
                <span className="customer-details-value">{customerDetails.name}</span>
              </div>
              <div className="customer-details-row">
                <span className="customer-details-label">Phone</span>
                <span className="customer-details-value">{customerDetails.phone}</span>
              </div>
              <div className="customer-details-row">
                <span className="customer-details-label">Email</span>
                <span className="customer-details-value">{customerDetails.email}</span>
              </div>
              <div className="customer-details-row">
                <span className="customer-details-label">Address</span>
                <span className="customer-details-value">{customerDetails.address}</span>
              </div>
            </div>
          )}
          <ul style={{margin: 0}}>
            {selectedItems.map(item => {
              const food = FOOD_ITEMS.find(f => f.name === item.name);
              return (
                <li key={item.name} style={{marginBottom: 4, fontSize: '1rem', padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  <span>
                    {item.name} <span style={{color:'#888'}}>x{item.quantity}</span>
                  </span>
                  <span style={{display: 'flex', alignItems: 'center'}}>
                    {showEditRemove && (
                      <>
                        <button
                          style={{background: 'none', border: 'none', color: '#007bff', fontSize: '1.2em', cursor: 'pointer', padding: 0, marginLeft: 4, display: 'flex', alignItems: 'center'}}
                          title="Edit item"
                          onClick={() => setEditItemName(item.name)}
                        >
                          <EditIcon />
                        </button>
                        <button
                          style={{background: 'none', border: 'none', color: '#eb6c20', fontSize: '1.2em', cursor: 'pointer', padding: 0, marginLeft: 4, display: 'flex', alignItems: 'center', marginRight: 12}}
                          title="Remove item"
                          onClick={() => setSelectedItems(selectedItems.filter(i => i.name !== item.name))}
                        >
                          <DeleteIcon />
                        </button>
                      </>
                    )}
                    <span style={{fontWeight: 500, margin: '0', width: 50, textAlign: 'right'}}>
                      ₹{food ? (food.price * item.quantity) : '0'}
                    </span>
                  </span>
                </li>
              );
            })}
          </ul>
          <div style={{marginTop: 8, display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: '1.1rem', marginRight: 0}}>
            <span>Items Total</span>
            <span style={{marginRight:  0}}>₹{round2Decimal(orderTotal)}</span>
          </div>
          {deliveryInfo.deliveryCharge > 0 && (<div style={{marginTop: 8, display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: '1.1rem', marginRight: 0}}>
            <span>Delivery Charge</span>
            <span style={{marginRight:  0}}>₹{round2Decimal(deliveryInfo.deliveryCharge)}</span>
          </div>)}
          <div className="order-total-bar" style={{marginTop: 8, display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: '1.1rem', marginRight: 0}}>
            <span>Order Total</span>
            <span style={{marginRight:  0}}>₹{round2Decimal(orderTotal + (deliveryInfo.deliveryCharge || 0))}</span>
          </div>
          {/* Inline delivery charge/info message */}
          {deliveryMsg && (
            <div style={{marginTop: 10, color: (deliveryInfo.error) ? 'red' : '#009e60', fontWeight: 500, textAlign: 'left', fontSize: '1rem'}}>
              {deliveryMsg}
            </div>
          )}
          {orderTotal < 250 && !deliveryMsg && (
            <div style={{marginTop: 10, color: '#eb6c20', fontWeight: 500, textAlign: 'left', fontSize: '1rem'}}>
              Enjoy free delivery on orders above <b>₹250</b>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
// Step component for selecting food items
function FoodItemSelectorStep({ error, setError, isFirstStep, isLastStep, onSelectionChange, setOrderTotal, editItemName, setEditItemName, selectedItems, setSelectedItems }) {
  const selectItemsRef = React.useRef();

  useEffect(() => {
    if (onSelectionChange) onSelectionChange(selectedItems);
    // Hide error if at least one item is selected
    if (selectedItems.length > 0 && error) {
      setError('');
    }
  }, [selectedItems, onSelectionChange, error, setError]);

  // Scroll to item in SelectItems when editItemName changes
  useEffect(() => {
    if (editItemName && selectItemsRef.current && selectItemsRef.current.scrollToItem) {
      selectItemsRef.current.scrollToItem(editItemName);
    }
  }, [editItemName]);

  // Calculate total
  const total = selectedItems.reduce((sum, item) => {
    const food = FOOD_ITEMS.find(f => f.name === item.name);
    return sum + (food ? food.price * item.quantity : 0);
  }, 0);

  // Update order total
  useEffect(() => {
    setOrderTotal(total);
  }, [total, setOrderTotal]);

  return (
    <div>
      <SelectItems
        ref={selectItemsRef}
        items={FOOD_ITEMS}
        selectedItems={selectedItems}
        onChange={setSelectedItems}
        scrollToAndHighlight={editItemName}
        onHighlightEnd={() => setEditItemName(null)}
      />
      {error && selectedItems.length === 0 && <div className="error-message pd-10">{error}</div>}
    </div>
  );
}

function CustomerDetailsStep({ customerDetails, setCustomerDetails, showLocationModal, setShowLocationModal, selectedDeliveryCoords, setSelectedDeliveryCoords, error, setError, orderTotal, deliveryInfo, setDeliveryInfo }) {
  return (
    <div className="pd-10">
      <UserDetailsForm customerDetails={customerDetails} setCustomerDetails={setCustomerDetails} error={error} />
    </div>
  );
}
function CustomerLocation({ customerDetails, setCustomerDetails, showLocationModal, setShowLocationModal, selectedDeliveryCoords, setSelectedDeliveryCoords, error, setError, orderTotal, deliveryInfo, setDeliveryInfo }) {
  return (
    <div className="pd-10">
      {React.createElement(require('../../components/location/location.jsx').default, {
        setCustomerDetails,
        context: CHOOSE_MENU_CONTEXT,
        orderTotal,
        deliveryInfo,
        setDeliveryInfo
      })}
      {error && <div className="error-message pd-10">{error}</div>}

    </div>
  );
}

const steps = [
  {
    label: 'Select Delivery Location',
    name: "deliveryLocation",
    component: (props) => <CustomerLocation {...props} />,
  },
  {
    label: 'Select Food Items',
    name: "foodItems",
    component: (props) => <FoodItemSelectorStep {...props} onSelectionChange={props.onSelectionChange} orderTotal={props.orderTotal} setOrderTotal={props.setOrderTotal} selectedItems={props.selectedItems} setSelectedItems={props.setSelectedItems} />, 
  },
  {
    label: 'Customer Details',
    name: "customerDetails",
    component: (props) => <CustomerDetailsStep {...props} />,
  },
   {
    label: 'Order Summary',
    name: "orderSummary",
    component: (props) => <OrderSummary {...props} />,
  },
];

const ChooseYourMenu = () => {
  const dispatch = useDispatch();
  // const submitting = useSelector(state => state.chooseMenu.submitting);
  // const submitSuccess1 = useSelector(state => state.chooseMenu);
  const submitSuccess = useSelector(state => state.chooseMenu.submitSuccess);
  const submitError = useSelector(state => state.chooseMenu.submitError);
  const orderResponse = useSelector(state => state.chooseMenu.orderResponse);
  const [currentStep, setCurrentStep] = useState(0);
  const [error, setError] = useState('');
  const [selectedItems, setSelectedItems] = useState([]); // For order total
  const [orderTotal, setOrderTotal] = useState(0);
  const [customerDetails, setCustomerDetails] = useState({ name: '', phone: '', email: '', address: '' });
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [editItemName, setEditItemName] = useState(null);
  const [deliveryInfo, setDeliveryInfo] = useState({ deliveryCharge: 0, message: '', deliveryDistance: 0, error: false });
  
  const StepComponent = steps[currentStep].component;
  useEffect(() => {
    document.title = 'Choose Your Menu';
    dispatch(pageAction('Choose Your Menu'));
    // Clear submitSuccess and submitError when landing on this screen
    dispatch({ type: 'SUBMIT_ORDER_SUCCESS', payload: null });
    dispatch({ type: 'SUBMIT_ORDER_FAILURE', payload: null });
  }, [dispatch]);

  // Recalculate delivery charges when selectedItems changes
  useEffect(() => {
    // You may need to get deliveryDistance from user details/location selection
    // For demo, assume deliveryDistance is available in customerDetails or selectedDeliveryCoords
    let deliveryDistance = deliveryInfo.deliveryDistance ?? undefined;
    // If deliveryDistance is not set, skip calculation
    if (deliveryDistance > 0 && orderTotal > 0) {
      // Import calculatePriceForCustomMenu at top if not already
      const { calculatePriceForCustomMenu } = require('../../utils/deliveryUtils');
      const info = calculatePriceForCustomMenu(deliveryDistance, orderTotal);
      setDeliveryInfo(info);
    }
  }, [selectedItems, orderTotal]);

    // Recalculate delivery charges when selectedItems changes
  useEffect(() => {
    if(customerDetails?.deliveryLocation) {
      setError("");
    }
  }, [customerDetails?.deliveryLocation]);

  // Hide error message once user enters all details in customerDetails step
  useEffect(() => {
    if (
      customerDetails.name &&
      customerDetails.phone &&
      customerDetails.email &&
      customerDetails.address &&
      steps[currentStep].name === 'customerDetails'
    ) {
      setError('');
    }
  }, [customerDetails, currentStep]);
  // Initiate payment when order is successfully submitted
  useEffect(() => {
    if (submitSuccess && orderResponse && orderTotal > 0) {
      // Prepare payment data from orderResponse and customerDetails
      const paymentData = {
        orderUid: orderResponse.orderUid || orderResponse.id || '',
        orderTotal: orderTotal,
        customerName: customerDetails.name,
        customerPhone: customerDetails.phone,
        customerEmail: customerDetails.email
      };
      dispatch(initiatePaymentRequest(paymentData));
    }
  }, [submitSuccess, orderResponse, orderTotal, customerDetails, dispatch]);

  const handleNext = () => {
    const stepName = steps[currentStep].name;
    // If not on deliveryLocation step, check if location is selected
    if (stepName === 'deliveryLocation') {
      if (!customerDetails.deliveryLocation) {
        setError('Please select your delivery location.');
        return;
      }
    }
    if (stepName === 'foodItems') {
      if (!selectedItems || selectedItems.length === 0) {
        setError('Please select at least one food item.');
        return;
      }
      setError('');
    }
    if (stepName === 'customerDetails') {
      if (!customerDetails.name || !customerDetails.phone || !customerDetails.email || !customerDetails.address) {
        setError('Please fill all details');
        return;
      }
      setError('');
    }
    setCurrentStep((prev) => prev + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handlePrev = () => {
    setCurrentStep((prev) => {
      const newStep = prev - 1;
      // Reset submitSuccess and submitError when returning to step 1 (deliveryLocation)
      if (steps[newStep]?.name === 'deliveryLocation') {
        dispatch({ type: 'SUBMIT_ORDER_SUCCESS', payload: null });
        dispatch({ type: 'SUBMIT_ORDER_FAILURE', payload: null });
      }
      return newStep;
    });
  };
  const isNextDisabled = deliveryInfo && deliveryInfo.deliveryDistance > require('../../utils/locationConstants').MAX_DELIVERY_RADIUS_KM;
  return (
    <div className="step-main-container pd-8">
      <div className="step-inner-container">
        <div className="steps-bar">
          <div
            key={steps[currentStep].label}
            className="step-label-new"
          >
            {steps[currentStep].label}
          </div>
        </div>
        <StepComponent
          error={error}
          setError={setError}
          isFirstStep={currentStep === 0}
          isLastStep={currentStep === steps.length - 1}
          orderTotal={orderTotal}
          setOrderTotal={setOrderTotal}
          onSelectionChange={setSelectedItems}
          editItemName={editItemName}
          setEditItemName={setEditItemName}
          customerDetails={customerDetails}
          setCustomerDetails={setCustomerDetails}
          showLocationModal={showLocationModal}
          setShowLocationModal={setShowLocationModal}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          deliveryInfo={deliveryInfo}
          setDeliveryInfo={setDeliveryInfo}
          stepName={steps[currentStep].name}
        />
      </div>
      
      {/* Show OrderSummary only if not on deliveryLocation or orderSummary step */}
      {(steps[currentStep].name !== 'deliveryLocation' && steps[currentStep].name !== 'orderSummary') && (
        <OrderSummary
          selectedItems={selectedItems}
          orderTotal={orderTotal}
          setSelectedItems={setSelectedItems}
          setEditItemName={setEditItemName}
          showEditRemove={steps[currentStep].name === 'foodItems'}
          deliveryInfo={deliveryInfo}
          customerDetails={customerDetails}
          stepName={steps[currentStep].name}
        />
      )}

      {/* Show submit success or error message */}
      {submitSuccess && (
        <div className="order-success-message" style={{ color: '#009e60', fontWeight: 600, marginBottom: 16 }}>
          Order placed successfully! We will contact you soon.
        </div>
      )}

      {submitError && (
        <div className="order-error-message" style={{ color: 'red', fontWeight: 600, marginBottom: 16 }}>
          {typeof submitError === 'string' ? submitError : 'Order submission failed. Please try again.'}
        </div>
      )}
      {/* Navigation Buttons outside the card */}
      <div className="buffet-button-container" style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginTop: 24 }}>
        {currentStep > 0 ? (
          <button
            className="primary-button buffet-step-button"
            onClick={handlePrev}
            type="button"
            style={{ minWidth: 120 }}
          >
            Previous
          </button>
        ) : <div />}
        {currentStep === steps.length - 1 ? (
          <button
            className="primary-button buffet-step-button"
            style={{ minWidth: 120 }}
            onClick={() => {
              // Final validation before confirming
              if (!selectedItems || selectedItems.length === 0) {
                setError('Please select at least one food item.');
                setCurrentStep(0);
                return;
              }
              if (!customerDetails.name || !customerDetails.phone || !customerDetails.email || !customerDetails.address) {
                setError('Please fill all details and select location.');
                setCurrentStep(1);
                return;
              }
              setError('');
              // Prepare order data for API
              const orderData = {
                customer: {
                  name: customerDetails.name,
                  phone: customerDetails.phone,
                  email: customerDetails.email,
                  address: customerDetails.address,
                  location: customerDetails.deliveryLocation || null
                },
                items: selectedItems.map(item => ({
                  name: item.name,
                  quantity: item.quantity
                })),
                orderTotal,
                deliveryInfo
              };
              // Dispatch Redux action to submit order
              dispatch(submitOrderRequest(orderData));
            }}
            type="button"
          >
            Confirm
          </button>
        ) : (
          <button
            className="primary-button buffet-step-button"
            onClick={handleNext}
            type="button"
            style={{ minWidth: 120, backgroundColor: isNextDisabled ? '#dcdada' : undefined, color: isNextDisabled ? '#888' : undefined, cursor: isNextDisabled ? 'not-allowed' : 'pointer', backgroundImage: isNextDisabled ? 'none' : undefined }}
            disabled={isNextDisabled}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default ChooseYourMenu;
